import React, { useState } from 'react'
import "./HomeHero.css"
import { useNavigate } from 'react-router-dom'
import CalendlyFormModal from '../CalendlyFormEmbed/CalendlyFormEmbed'
import Modal from '../Modal/Modal'

function HomeHero({
    textCtaBlack=false,
    showLogo=true,
    heading="Raising the bar on personalized care.",
    spanHeading="",
    afterSpanHeading="",
    content="A concierge approach to executive healthcare that is personalized, proactive, and designed to support you throughout your health journey.",
    plainCta=true,
    headingBlack=false,
    sideImage=false,
    bgImage="/images/creatives/home-hero-img.webp",
    fullWidth=false,
    textCenter=false,
    largePara=true,
    btn=true,
    paraH2=false,
    btnText="",
    btnLink="/membership",
    btnrefTel=false,
    btnCalnedly=false,
    calendlyType=0
}) {
    const navigate = useNavigate()
    const [openCalendly, setOpenCalendly] = useState(false);
  return (
    <div className={`HomeHero-container standard-padding-space d-flex ${textCenter && "regulated-height"}`}
        style={{backgroundImage:`url(${bgImage})`}}
    >
         {
            openCalendly &&
            <CalendlyFormModal intialOpenState={openCalendly} setOpenState={setOpenCalendly} calendlyType={calendlyType}/>
        }
      
        <div className='container h-100 my-auto'>
            <div className={`row ${sideImage && "gy-lg-o gy-4 align-items-center" }`}>
                <div className={`${fullWidth ? "col-12":"col-lg-6"} ${textCenter ?"text-lg-center":"text-lg-start"}  text-center`}>
                    <h1 className={`main-heading main-title pb-1 ${headingBlack ? "color-dark":"color-light"} `} style={{textTransform:"none"}}>{heading} 
                        {spanHeading && <span style={{color:"#208AE7"}}>{spanHeading}</span>}
                        {afterSpanHeading && afterSpanHeading}
                    </h1>
                    {
                        paraH2?
                        <h2 className={`body-paragraph ${largePara && "largePara"}  my-3 mb-4 ${textCtaBlack ?"color-dark":"color-light"} ${textCenter ?"px-5":""}`}>{content}</h2>
                        :
                        <p className={`body-paragraph ${largePara && "largePara"}  my-3 mb-4 ${textCtaBlack ?"color-dark":"color-light"} ${textCenter ?"px-5":""}`}>{content}</p>
                    }
                    {
                        btn &&
                        <div className='d-flex gap-3 mt-4 flex-lg-row flex-column px-lg-0 px-5'>

                            <button className='genral-btn-narrow' onClick={()=>{if(btnrefTel){btnCalnedly?setOpenCalendly(true):window.open(btnrefTel)}else{btnCalnedly?setOpenCalendly(true):navigate(btnLink)}}}>{btnText? btnText :"Explore membership"}</button>
                            {
                                plainCta &&
                                <button className={`genral-btn-white ${textCtaBlack &&"color-dark"}`} onClick={()=>{navigate("/service")}}>Learn more →</button>
                            }

                        </div>
                    }

                    {
                        showLogo &&
                        <div className='d-flex align-items-center justify-content-center justify-content-lg-start'>
                            <img src='/images/icons/logo-white.png' alt='logo' className='img-fluid logoImg mt-4' style={{maxHeight:"100px"}} />

                        </div>
                    }

                </div>
                {
                    sideImage &&
                    <div className='col-lg-6 d-flex align-items-center justify-content-center'>
                        <img src={sideImage} className='img-fluid' alt='side ' />
                    </div>
                }

            </div>
        </div>
    </div>
  )
}

export default HomeHero